import { useEffect } from 'react';

import { useChatContext } from '../../../context/ChatContext';

import type { Channel, Event } from 'belo-js-sdk';

import type { DefaultBeloChatGenerics } from '../../../types/types';

export const useChannelHiddenListener = <
  BeloChatGenerics extends DefaultBeloChatGenerics = DefaultBeloChatGenerics
>(
  setChannels: React.Dispatch<React.SetStateAction<Array<Channel<BeloChatGenerics>>>>,
  customHandler?: (
    setChannels: React.Dispatch<React.SetStateAction<Array<Channel<BeloChatGenerics>>>>,
    event: Event<BeloChatGenerics>,
  ) => void,
) => {
  const { client } = useChatContext<BeloChatGenerics>('useChannelHiddenListener');

  useEffect(() => {
    const handleEvent = (event: Event<BeloChatGenerics>) => {
      if (customHandler && typeof customHandler === 'function') {
        customHandler(setChannels, event);
      } else {
        setChannels((channels) => {
          const channelIndex = channels.findIndex((channel) => channel.cid === event.cid);
          if (channelIndex < 0) return [...channels];

          // Remove the hidden channel from the list.s
          channels.splice(channelIndex, 1);

          return [...channels];
        });
      }
    };

    client.on('channel.hidden', handleEvent);

    return () => {
      client.off('channel.hidden', handleEvent);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customHandler]);
};
